import store from '../store'

export default (to, from, next) => {
  let user = store.getters['usuario/user']
  if (user)
    if (user.permisos.root)
      next()
    else
      next('/')
  else
    next('/acceso')
}
